import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'lib-project-number-cell-renderer',
  standalone: true,
  imports: [],
  template: `
    <div class="project-cell">
      @if (customer) {
      <img
        class="customer-icon"
        [src]="getCustomerIconUrl()"
        alt="{{ customer }}"
        onerror="this.src='assets/icons/icon-72x72.png'"
      />
      }
      <span>{{ projectNumber }}</span>
    </div>
  `,
  styles: [
    `
      .project-cell {
        display: flex;
        align-items: center;
        gap: 8px;
        height: 100%;
      }

      .customer-icon {
        border-radius: 5px;
        width: 30px;
        height: 30px;
        flex-shrink: 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectNumberCellRenderer implements ICellRendererAngularComp {
  params!: ICellRendererParams<any>;
  data!: any;
  projectNumber!: string;
  customer!: string;

  agInit(params: ICellRendererParams<any>): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams<any>) {
    this.params = params;
    this.data = params.data;

    // params.data is undefined for not-yet-loaded rows under AG Grid's infinite row model —
    // it fills in once that block's getRows() resolves and this renderer refreshes again.
    if (!this.data) {
      this.projectNumber = '';
      this.customer = '';
      return true;
    }

    if (this.data.project) {
      this.projectNumber = this.data.project?.projectNumber || this.data.projectNumber;
      this.customer = this.data.project?.customer?.shortName || this.data.project.customerString;
    } else {
      this.projectNumber = this.data.projectNumber;
      this.customer = this.data?.customer?.shortName || this.data.customerString;
    }
    return true;
  }

  getCustomerIconUrl(): string {
    return `assets/images/customers/${this.customer?.toLowerCase().trim()}/icon.png`;
  }
}
